import { z } from "zod";

export const windowDecorationColorSchema = z.object({
    id: z.string().nullish(),
    hexColor: z.string().nullish(),
    name: z.string().nullish(),
    price: z.number().nullish(),
    type: z.enum(["SUN_BLOCKING", "TRANSLUCENT"]).nullish(),
    image: z.object({ url: z.string().nullish() }).nullish(),
});

export const windowDecorationSchema = z.object({
    id: z.string(),
    name: z.string(),
    subtitle: z.string().nullish(),
    image: z.object({ url: z.string().nullish() }).nullish(),
    colors: z.array(windowDecorationColorSchema).nullish(),
});

export const windowDecorationsResponseSchema = z.object({
    WindowDecorations: z.object({
        docs: z.array(windowDecorationSchema),
    }),
});
